export function isPermissionDeniedError(error: Error) {
  return /permission\sdenied/i.test(error.message) || /not\sallowed/i.test(error.message);
}

export function isRateLimitError(error: Error) {
  return /rate\slimit/i.test(error.message);
}
